import React from 'react';
import { Plane, Map, Clock, Car, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const Services = () => {
  const services = [
    {
      icon: Plane,
      title: 'Airport Transfers',
      description: 'Reliable pickup and drop services to all airports. Never miss a flight with our punctual service.',
      features: ['On-time pickup', 'Flight tracking', 'Meet & greet service'],
    },
    {
      icon: Map,
      title: 'Outstation Trips',
      description: 'Comfortable long-distance travel to any destination. Explore beyond the city with ease.',
      features: ['Experienced drivers', 'Well-maintained vehicles', 'Flexible stops'],
    },
    {
      icon: Clock,
      title: 'Hourly Rentals',
      description: 'Book a cab by the hour for your local errands, meetings, or city tours.',
      features: ['Minimum 4 hours', 'Multiple stops allowed', 'Best for city tours'],
    },
    {
      icon: Car,
      title: 'Corporate Services',
      description: 'Professional transportation solutions for your business needs and corporate events.',
      features: ['Monthly packages', 'Invoice billing', 'Dedicated support'],
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="lux-overline mb-4">Our Services</p>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold text-white mb-4 tracking-tight">
            Cab Services in Bangalore — Airport, Outstation &amp; Rentals
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            From airport runs to outstation adventures, we've got your transportation needs covered
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((service) => (
            <Card
              key={service.title}
              className="group lux-card rounded-2xl transition-all duration-300 hover:-translate-y-1"
            >
              <CardContent className="p-8">
                <div className="flex items-start space-x-5">
                  <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#d4af37]/10 border border-[#d4af37]/30 flex items-center justify-center">
                    <service.icon className="w-6 h-6 text-[#d4af37]" aria-hidden="true" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-display text-xl font-semibold text-white mb-3 group-hover:text-[#d4af37] transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-gray-400 mb-4 leading-relaxed text-sm">
                      {service.description}
                    </p>
                    <ul className="space-y-2">
                      {service.features.map((feature) => (
                        <li key={feature} className="flex items-center text-sm text-gray-300">
                          <div className="w-1.5 h-1.5 rounded-full bg-[#d4af37] mr-3"></div>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 mb-6">
            Need a custom service package? We're here to help!
          </p>
          <a href="tel:+917507867648">
            <button
              data-testid="services-contact-btn"
              className="inline-flex items-center px-9 py-3.5 rounded-full bg-[#d4af37] hover:bg-[#c9a35c] text-black font-semibold transition-colors"
            >
              Contact Us for Custom Plans
              <ArrowRight className="ml-2 w-5 h-5" aria-hidden="true" />
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};
